import {match} from 'ts-pattern';

import {always} from 'ramda';

import i18n from '@dms/i18n';

import type {RentalCalendarFilterValues} from '../types/RentalCalendarFilterValues';

/** One label per filter, shared by the filter panel and the active-filter chips */
export function getRentalCalendarFilterLabel(key: keyof RentalCalendarFilterValues) {
  return match<keyof RentalCalendarFilterValues, string>(key)
    .with('vehicleId', always(i18n.t('general.labels.vehicle')))
    .with('vehicleCategory', always(i18n.t('entity.rental.labels.vehicleCategory')))
    .with('carPark', always(i18n.t('entity.rental.labels.carParkId')))
    .with('vehicleType', always(i18n.t('entity.vehicle.labels.type')))
    .with('make', always(i18n.t('entity.vehicle.labels.make')))
    .with('modelFamily', always(i18n.t('entity.vehicle.labels.model')))
    .with('bodyStyle', always(i18n.t('entity.vehicle.labels.body')))
    .with('fuelType', always(i18n.t('entity.vehicle.labels.fuel')))
    .with('transmission', always(i18n.t('entity.vehicle.labels.transmission')))
    .with('drive', always(i18n.t('entity.vehicle.labels.drive')))
    .with('doorCount', always(i18n.t('entity.vehicle.labels.numberOfDoors')))
    .with('seatCount', always(i18n.t('entity.vehicle.labels.numberOfSeats')))
    .exhaustive();
}
